import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-profile-loading',
    templateUrl: './profile-loading.component.html',
    styleUrls: ['./profile-loading.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatProgressSpinnerModule,
      MatDividerModule,
      NgxSkeletonLoaderModule
    ]
})
export class ProfileLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
